export enum IConversationsOrderByType {
  DueDate = 0,
  CaseNo = 1,
  Description = 2,
  Category = 3,
}
